export default __webpack_public_path__ + "static/planning-poker-voting-5922e842986b1c8f927b6b1e1c217174.webm";